export enum StatusAtutorizacaoPlaca {
  Processando = 1,
  Finalizado = 2,
  Erro = 3,
  'Finalização manual' = 4,
}
